/**
 * This is the script provided by Yotpo team.
 * Need to add setTimeout as this is not working without timeout
 */
export const yotpoStarNoReviews = () => {
    let yotpoIsReady = false
    const getWidget = () => {
        setTimeout(function () {
            if (
                typeof window !== 'undefined' &&
                typeof window.yotpo !== 'undefined'
            ) {
                if (
                    window.yotpo.initialized === true &&
                    window.yotpo?.inview?.allWidgetsAreReady === true
                ) {
                    yotpoIsReady = true
                    const starRating = document.querySelectorAll(
                        '.bottomLine.plpBottomLine'
                    )
                    for (let i = 0; i < starRating.length; i++) {
                        const starsContent = starRating[i].innerHTML
                        if (!starsContent.includes('yotpo-stars')) {
                            const emptyStars = document.createElement('div')
                            emptyStars.className = 'yotpo-display-wrapper'
                            emptyStars.innerHTML = `<div class="standalone-bottomline" style="display:inline-block">
                                              <div class="yotpo-bottomline pull-left  star-clickable"><span class="yotpo-stars">
                                              <span class="yotpo-icon yotpo-icon-empty-star pull-left"></span>
                                             <span class="yotpo-icon yotpo-icon-empty-star pull-left"></span>
                                             <span class="yotpo-icon yotpo-icon-empty-star pull-left"></span>
                                             <span class="yotpo-icon yotpo-icon-empty-star pull-left"></span>
                                             <span class="yotpo-icon yotpo-icon-empty-star pull-left"></span> </span>
                                             <a href="javascript:void(0)" class="text-m">0 Review</a>
                                             <div class="yotpo-clr"></div> </div><div class="yotpo-clr"></div></div><br>`

                            starRating[i].innerHTML = ''
                            starRating[i].appendChild(emptyStars)
                        }
                    }
                }
            }
            if (!yotpoIsReady) getWidget()
        }, 300)
    }
    return getWidget()
}
